import { HeadCell } from "@/components/app/EnhancedTableHeader/type";

export interface Data {
    id: number;
    user: string;
    action: string;
    entity: string;
    entityId?: number;
    method: string;
    statusCode: number;
    ipAddress: string;
    isError: boolean;
    createdAt: string;
    requestBody?: string;
    responseBody: string;
}

const headCells: HeadCell<Data>[] = [
    {
        id: "id",
        numeric: true,
        disablePadding: false,
        label: "ID",
    },
    {
        id: "user",
        numeric: false,
        disablePadding: false,
        label: "User",
    },
    {
        id: "action",
        numeric: false,
        disablePadding: false,
        label: "Action",
    },
    {
        id: "entity",
        numeric: false,
        disablePadding: false,
        label: "Entity",
    },
    // {
    //   id: "entityId",
    //   numeric: true,
    //   disablePadding: false,
    //   label: "Entity ID",
    // },
    {
        id: "method",
        numeric: false,
        disablePadding: false,
        label: "Method",
    },
    {
        id: "statusCode",
        numeric: true,
        disablePadding: false,
        label: "Status",
    },
    {
        id: "ipAddress",
        numeric: false,
        disablePadding: false,
        label: "IP Address",
    },
    {
        id: "isError",
        numeric: false,
        disablePadding: false,
        label: "Status",
    },
    {
        id: "createdAt",
        numeric: false,
        disablePadding: false,
        label: "Date & Time",
    },
];

export default headCells;
